import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Picker, List, WhiteSpace } from 'antd-mobile/lib';
import { createForm } from 'rc-form';
import Util from '../../util.js';
import {AdjustRecordContent} from './CommonComponents.js'
import { hashHistory } from 'react-router';
import NavigatorMain from '../NavigatorMain';


/*智投交易记录*/
class TransitHistoryDetail extends Component {
   goBack() {
    hashHistory.goBack();
  }
  componentDidMount(){
    document.title = '历史调仓详情'
  }
  render() {
    return (
        <div className="container">
          <NavigatorMain>
          <div className="header black">
            <div ><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
            <div >历史调仓详情</div>
            <div ></div>    
          </div>
          </NavigatorMain>
          <div className='content TransitHistory-content'>
            <AdjustRecordContent data={this.props.location.state.data}/>
          </div>
          
        </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    QueryTradeRecords:state.QueryTradeRecords,
    SupperFundHome:state.SupperFundHome,
  }
}

export default connect(mapStateToProps)(TransitHistoryDetail);





// WEBPACK FOOTER //
// ./src/components/fundDetail/TransitHistoryDetial.js